import { useCallback } from "react";
import { useGenerationPhase, type GenerationPhase } from "./useGenerationPhase";
import type { FingerprintOutput } from "../types/voice";

export type RefinePhase = GenerationPhase;

type Result = { profile: FingerprintOutput; systemPrompt: string };

interface UseRefineWs {
  refine: (feedback: string) => void;
  phase: RefinePhase;
  result: Result | null;
  error: string | null;
  reset: () => void;
}

export const useRefineWs = (): UseRefineWs => {
  const { start, phase, result, error, reset } = useGenerationPhase<Result>({
    action: "refine",
    parseResult: (msg) => ({
      profile: msg.profile as FingerprintOutput,
      systemPrompt: msg.systemPrompt as string,
    }),
  });

  const refine = useCallback(
    (feedback: string) => {
      start({ feedback });
    },
    [start]
  );

  return { refine, phase, result, error, reset };
};
